import { CIcon } from '~/icons/types'

export const ciMyClassifieds: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21 9.2V9c0-1.7-1.3-3-3-3h-3.9c-.2 0-.4-.1-.5-.2l-2.1-2.1c-.5-.5-1-.7-1.6-.7H6C4.3 3 3 4.3 3 6v3.2C1.7 9.7.9 11 1.1 12.4l.9 6c.2 1.5 1.5 2.6 3 2.6h14c1.5 0 2.8-1.1 3-2.6l.9-6c.2-1.4-.6-2.7-1.9-3.2ZM4.5 6c0-.8.7-1.5 1.5-1.5h3.9c.2 0 .4.1.5.2l2.1 2.1c.4.4 1 .7 1.6.7H18c.8 0 1.5.7 1.5 1.5h-15V6Zm16.9 6.2-.9 6c-.1.7-.7 1.3-1.5 1.3H5c-.7 0-1.4-.6-1.5-1.3l-.9-6c-.1-.8.4-1.6 1.2-1.7H20c.9.1 1.5.9 1.4 1.7Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'my-classifieds',
  type: 'light'
}
